// src/infra/api/PlanosAcao.js
import axiosInstance from '../axios';

/**
 * Plano de ações do produtor (plano LEITE). Cada item vem como
 * `{ plano, antes, depois, depoisAutomatico, vencida }` — `antes`/`depois` são o
 * resultado resumido das amostras (ResultadoColeta), já resolvidos pelo backend.
 *
 * Toda escrita avisa a barra lateral e o painel (`avisarPlanosAlterados`).
 */

export const EVENTO_PLANOS_ALTERADOS = 'bioailab:planos-acao-alterados';

export const avisarPlanosAlterados = () => {
    try {
        window.dispatchEvent(new Event(EVENTO_PLANOS_ALTERADOS));
    } catch {
        /* sem window (teste): nada a avisar */
    }
};

/**
 * status: 'ABERTA' | 'CONCLUIDA' | null (todas); pagina: 'LEITE' | 'COLOSTRO' | 'AGUA' |
 * null (todas). Responde PageResponse.
 */
export async function listarPlanosAcao({ status = null, pagina = null, busca = '', page = 0, size = 20 } = {}) {
    const res = await axiosInstance.get('/planos-acao', {
        params: { status: status || undefined, pagina: pagina || undefined, busca: busca || undefined, page, size },
    });
    return res.data;
}

/** `{ abertas, vencidas }` */
export async function resumoPlanosAcao() {
    const res = await axiosInstance.get('/planos-acao/resumo');
    return res.data;
}

export async function criarPlanoAcao(dados) {
    const res = await axiosInstance.post('/planos-acao', dados);
    avisarPlanosAlterados();
    return res.data;
}

export async function atualizarPlanoAcao(id, dados) {
    const res = await axiosInstance.put(`/planos-acao/${id}`, dados);
    avisarPlanosAlterados();
    return res.data;
}

/** `{ execucaoEm, registro, amostraDepoisId? }` */
export async function concluirPlanoAcao(id, dados) {
    const res = await axiosInstance.post(`/planos-acao/${id}/concluir`, dados);
    avisarPlanosAlterados();
    return res.data;
}

export async function excluirPlanoAcao(id) {
    await axiosInstance.delete(`/planos-acao/${id}`);
    avisarPlanosAlterados();
}
